import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class Employee_Dashboard_BasicDetailDto implements IEmployee_Dashboard_BasicDetailDto {
    employee!: EmployeeSummaryDto;
    profileImageUrl!: string | undefined;
    mobileNo!: string | undefined;
    email!: string | undefined;
    joinDate!: Date | undefined;
    birthDate!: Date | undefined;
    basicSalary!: number;
    departmentName!: string | undefined;
    gender!: string | undefined;
    experience!: string | undefined;
    designationName!: string | undefined;
    shiftName!: string | undefined;
    employeeTotalExperience!: string | undefined;

    constructor(data?: IEmployee_Dashboard_BasicDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.profileImageUrl = _data["profileImageUrl"];
            this.mobileNo = _data["mobileNo"];
            this.email = _data["email"];
            this.joinDate = _data["joinDate"] ? new Date(_data["joinDate"].toString()) : <any>undefined;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.basicSalary = _data["basicSalary"];
            this.departmentName = _data["departmentName"];
            this.gender = _data["gender"];
            this.experience = _data["experience"];
            this.designationName = _data["designationName"];
            this.shiftName = _data["shiftName"];
            this.employeeTotalExperience = _data["employeeTotalExperience"];
        }
    }

    static fromJS(data: any): Employee_Dashboard_BasicDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new Employee_Dashboard_BasicDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["profileImageUrl"] = this.profileImageUrl;
        data["mobileNo"] = this.mobileNo;
        data["email"] = this.email;
        data["joinDate"] = this.joinDate ? this.joinDate.toISOString() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["basicSalary"] = this.basicSalary;
        data["departmentName"] = this.departmentName;
        data["gender"] = this.gender;
        data["experience"] = this.experience;
        data["designationName"] = this.designationName;
        data["shiftName"] = this.shiftName;
        data["employeeTotalExperience"] = this.employeeTotalExperience;
        return data; 
    }
}

export interface IEmployee_Dashboard_BasicDetailDto {
    employee: EmployeeSummaryDto;
    profileImageUrl: string | undefined;
    mobileNo: string | undefined;
    email: string | undefined;
    joinDate: Date | undefined;
    birthDate: Date | undefined;
    basicSalary: number;
    departmentName: string | undefined;
    gender: string | undefined;
    experience: string | undefined;
    designationName: string | undefined;
    shiftName: string | undefined;
    employeeTotalExperience: string | undefined;
}

